import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { LandingShadcn } from '../../pages/LandingShadcn'
import { Login } from '../../pages/Login'
import { SSOAuth } from '../../pages/SSOAuth'
import { Spinner } from '../ui/spinner'
import { AuthenticatedApp } from './AuthenticatedApp'
import '../../styles/overrides.less'
import { useIntegrationSetup } from '@/integrations'

export const Main = () => {
  const { isAuthenticated, isLoading } = useAuth()
  useIntegrationSetup()

  if (isLoading) {
    return <Spinner />
  }

  return (
    <Routes>
      <Route path='/landing' element={<LandingShadcn />} />
      <Route path='/login' element={<Login />} />
      <Route path='/ssoAuth' element={<SSOAuth />} />
      <Route
        path='/*'
        element={
          isAuthenticated ? (
            <Suspense fallback={<Spinner />}>
              <AuthenticatedApp />
            </Suspense>
          ) : (
            <Navigate to='/login' replace />
          )
        }
      />
    </Routes>
  )
}
